import type { JSX } from 'react';

import { Panel } from '../ds';
import type { MyPlanCardDto } from '../../lib/api/openingTasks';
import { currentStage, daysLabel, fmtDMY } from './plan-model';

/** «Свойства» (правая колонка Обзора): куратор, дни на этапе против нормы, задачи этапа, дата старта. */
export function PlanProperties({ card }: { card: MyPlanCardDto }): JSX.Element {
  const cur = currentStage(card);
  return (
    <Panel pad={0} title="Свойства">
      <dl className="fk-op-props">
        <div className="fk-op-prop">
          <dt>Куратор</dt>
          <dd>{card.curatorName ?? 'назначается'}</dd>
        </div>
        <div className="fk-op-prop">
          <dt>На этапе</dt>
          <dd data-tone={card.overNorm ? 'bad' : undefined}>
            {daysLabel(card.daysOnStage)}
            {card.normDays != null ? ` из ${card.normDays} по норме` : ''}
          </dd>
        </div>
        {cur ? (
          <div className="fk-op-prop">
            <dt>Задачи этапа</dt>
            <dd>
              {cur.tasksDone} из {cur.tasksTotal}
            </dd>
          </div>
        ) : null}
        <div className="fk-op-prop">
          <dt>Начата</dt>
          <dd>{fmtDMY(card.startedAt)}</dd>
        </div>
      </dl>
    </Panel>
  );
}
